"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalStorage = void 0;
const tslib_1 = require("tslib");
const react_1 = require("react");
const fromStorage_1 = tslib_1.__importDefault(require("./fromStorage"));
const toStorage_1 = tslib_1.__importDefault(require("./toStorage"));
const useLocalStorage = (storageName, initialValue, decoder = JSON.parse, encoder = JSON.stringify, logger) => {
    const storage = window.localStorage;
    const from = (0, fromStorage_1.default)(storage)({ storageName, decoder, initialValue, logger });
    const to = (0, toStorage_1.default)(storage)(storageName, encoder);
    const [storedValue, setStoredValue] = (0, react_1.useState)(from());
    return [
        storedValue,
        (value) => {
            to(value);
            setStoredValue(value);
        },
    ];
};
exports.useLocalStorage = useLocalStorage;
